import React from 'react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface ErrorModalProps {
  visible: boolean
  title?: string
  renderBody: React.ReactNode
  onCancel: () => void
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  visible,
  title = 'Error',
  renderBody,
  onCancel,
}) => {
  return (
    <Dialog open={visible} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent overlayClassName='z-2060' className='z-2060'>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{renderBody}</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button onClick={onCancel}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ErrorModal
